import { useEffect, useState } from "react";
import { useCaja } from "../../../contexto/provider/CajaSesionContext.js";

import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../componentsUI/formularios/button/BotonAction.js";
import SesionCard from "../sesionCard/sesionCard.js";

export default function ListaSesionesCaja() {
  const { listarSesiones, loading, error } = useCaja();
  const [sesiones, setSesiones] = useState([]);
  const [abiertaId, setAbiertaId] = useState(null);

  useEffect(() => {
    const cargar = async () => {
      const data = await listarSesiones();
      console.log("[ListaSesionesCaja] data completa:", data);
      setSesiones(data);
    };
    cargar();
  }, [ listarSesiones]);

  useEffect(() => {
  const cargar = async () => {
    const data = await listarSesiones();
        console.log("[ListaSesionesCaja] data completa:", data);
    setSesiones(data);
  };
  cargar();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const toggleSesion = (id) => {
    setAbiertaId((prev) => (prev === id ? null : id));
  };

  if (loading) return <p>Cargando sesiones...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <TituloModulo titulo="Panel de sesiones" />
      <BotonAccion onClick={() => listarSesiones({ fuerza: true })}>
        Cargar
      </BotonAccion>

      <div className="contenedor-lista">
        {sesiones.length === 0 ? (
          <p>No hay sesiones registradas</p>
        ) : (
          sesiones.map((sesion) => (
            <SesionCard
              key={sesion.idSesion}
              sesion={sesion}
              abierta={abiertaId === sesion.idSesion}
              onToggle={() => toggleSesion(sesion.idSesion)}
            />
          ))
        )}
      </div>
    </div>
  );
}
